import React from 'react';
import {classes, style} from './doppe-action-type-widget-header.st.css';
import {FlexLayout} from '@wix/devzai-common-client';
import {Icon} from '@wix/devzai-utils-react';
import {IDoppeViewerActionContext} from '../../doppe-sdk';
import {OmitStrict} from '@wix/devzai-utils-common';
import {
    doppeHideableValueGetValue,
    doppeHideableValueIsVisible
} from '../../client-server-common/types/doppe-hideable-value';
import {DoppeDtoActionViewType} from "../../client-server-common/types/doppe-dto-action";

export const DoppeActionTypeWidgetHeader = React.memo(function DoppeActionTypeWidgetHeader(
    props: DoppeActionTypeWidgetHeader.Props
) {
    const {
        icon,
        actionContext,
        hasBorderBottom,

        onClick,
        className,
        ...htmlAttributes
    } = props;

    return (
        <h1
            {...htmlAttributes}
            className={style(classes.root, {
                withIcon: icon !== undefined,
                canBeToggled: actionContext.canBeToggled(),
                hasBorderBottom: hasBorderBottom,
                isOnPage: actionContext.getActionViewType() === DoppeDtoActionViewType.InPageFrameless,
            }, className, FlexLayout.row.alignToTop)}
            onClick={(event) => {
                if (actionContext.canBeToggled()) {
                    actionContext.toggleActionView(false);
                }

                onClick?.(event);
            }}
        >
            {icon ? (
                <Icon
                    className={style(classes.patreonIcon, {})}
                    icon={icon}
                />
            ) : null}
            <div
                className={style(classes.titleTextContainer, {}, FlexLayout.column.default, FlexLayout.fillRemainingHorizontalSpace)}
            >
                <div
                    className={style(classes.titleText, {})}
                >
                    {actionContext.action.name}
                </div>
                {
                    doppeHideableValueIsVisible(actionContext.action.callToActionDescription) ?
                        <div
                            className={style(classes.titleDescription, {})}
                        >
                            {doppeHideableValueGetValue(actionContext.action.callToActionDescription)}
                        </div>
                        :
                        null
                }

            </div>
        </h1>
    );
});

export namespace DoppeActionTypeWidgetHeader {

    export interface Props extends OmitStrict<React.HTMLAttributes<any>, 'title'> {
        icon?: Icon.Src;
        actionContext: IDoppeViewerActionContext<any>;
        hasBorderBottom: boolean;
    }
}
